import { ClipPath, Defs, G, Path } from "react-native-svg";
import { createIcon } from "../Icon";

export const MarkerIcon = createIcon({
	viewBox: "0 0 40 40",
	path: (
		<>
			<Path
				fill="#fffb0a"
				stroke="#00282d"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth={2}
				d="M20 2.667a14.001 14.001 0 0 1 14 14c0 4.385-2.42 8.78-5.139 12.353-2.735 3.593-5.858 6.463-7.425 7.816l-.035.029a2.33 2.33 0 0 1-1.21.459l-.202.009a2.33 2.33 0 0 1-1.235-.36l-.155-.108-.035-.03c-1.567-1.352-4.69-4.222-7.425-7.815C8.419 25.447 6 21.052 6 16.667a14.001 14.001 0 0 1 14-14"
			/>
			<G clipPath="url(#a)">
				<Path
					fill="#00282d"
					stroke="transparent"
					d="M17.194 24.351c-.796-.491.21-3.092.503-4.865.172-1.034-2.043-.359-2.667-.555-1.465-.455.045-3.02 2.767-5.868s4.102-3.834 5.067-3.506-.175 3.403-.597 5.595c-.208 1.085 2.173.328 2.776.603.886.4.823 1.495-2.616 5.199-3.44 3.705-4.636 3.762-5.233 3.397"
				/>
			</G>
			<Defs>
				<ClipPath id="a">
					<Path fill="#fff" d="M14.469 9.5h11.063v15H14.469z" />
				</ClipPath>
			</Defs>
		</>
	),
});
